import { Hexagon } from "lucide-react";
import { IMAGES, PARTNER_TIERS } from "../data/content";
import { PageHero } from "../components/shared/PageHero";
import { Reveal } from "../components/shared/Reveal";
import { SectionHead } from "../components/shared/SectionHead";
import { PrimaryButton } from "../components/shared/Buttons";

export default function Partners() {
  return (
    <>
      <PageHero
        eyebrow="Partners & Sponsors"
        title="Stand With Us"
        intro="Kumite Games will offer premium partnership opportunities for brands, sporting organisations, community partners and commercial sponsors — built around New Zealand's martial arts community."
        image={IMAGES.spectator}
        testId="partners-page-hero"
      />
      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
        {PARTNER_TIERS.map((tier, ti) => (
          <div key={tier.name} className={ti > 0 ? "mt-16" : ""}>
            <SectionHead
              eyebrow={`Tier ${String(ti + 1).padStart(2, "0")}`}
              title={tier.name}
              testId={`tier-heading-${tier.name.toLowerCase().replace(/\s+/g, "-")}`}
            />
            <div className="grid grid-cols-2 gap-5 lg:grid-cols-4">
              {Array.from({ length: tier.slots }).map((_, i) => (
                <Reveal
                  key={i}
                  delay={i * 0.06}
                  className="grid h-32 place-items-center border border-dashed border-white/10 bg-ink-soft/60 transition-colors duration-300 hover:border-gold/40 sm:h-36"
                >
                  <div data-testid={`partner-slot-${tier.name.toLowerCase().replace(/\s+/g, "-")}-${i}`} className="text-center">
                    <Hexagon className="mx-auto h-6 w-6 text-slate-600" />
                    <p className="mt-3 font-mono text-[9px] uppercase tracking-[0.3em] text-slate-600">
                      Partner Logo
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        ))}

        <Reveal delay={0.1} className="mt-20 clip-notch border border-kred/25 bg-kred/[0.05] p-10 text-center sm:p-16">
          <h2 data-testid="partners-cta-heading" className="font-display text-4xl uppercase tracking-wide text-bone sm:text-6xl">
            Partner With <span className="text-kred">Kumite Games</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-slate-400 sm:text-base">
            From major partnerships to community support, we are building a partnership family
            that reflects the values of martial arts — respect, discipline and excellence.
          </p>
          <div className="mt-10">
            <PrimaryButton to="/contact" testId="partners-enquiry-button">
              Partnership Enquiries
            </PrimaryButton>
          </div>
        </Reveal>
      </section>
    </>
  );
}
